module.exports = __webpack_public_path__ + "img/map.459eafd1.png";